module.exports = __webpack_public_path__ + "static/media/03.1b62a4d7.mp3";